import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import actions from './actions'
import mutations from './mutations'
import { Store as LexWebUiStore } from 'aws-lex-web-ui'
Vue.use(Vuex)
const store = new Vuex.Store(LexWebUiStore)
export default new Vuex.Store({
  state,
  actions,
  mutations,
  store
})



// WEBPACK FOOTER //
// ./src/store/index.js